import React, { useEffect, useMemo, useState } from "react";
import { Search, Users } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import CounsellorCard from "../components/CounsellorCard";
import { api } from "../lib/api";

export default function CounsellorsDirectory() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");
  const [city, setCity] = useState("all");
  const [spec, setSpec] = useState("all");

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get("/counsellors/public").then((r) => setList(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const cities = useMemo(() => ["all", ...Array.from(new Set(list.map((c) => c.city).filter(Boolean)))], [list]);
  const specs = useMemo(() => ["all", ...Array.from(new Set(list.map((c) => c.specialization).filter(Boolean)))], [list]);

  const filtered = list.filter((c) => {
    const matchesQ = !q || `${c.name} ${c.specialization} ${c.qualification} ${c.city}`.toLowerCase().includes(q.toLowerCase());
    const matchesCity = city === "all" || c.city === city;
    const matchesSpec = spec === "all" || c.specialization === spec;
    return matchesQ && matchesCity && matchesSpec;
  });

  return (
    <div className="min-h-screen bg-[#f6f8fc] flex flex-col">
      <Header />
      <main className="flex-1">
        <section className="bg-[#16244F] py-16 md:py-20">
          <div className="max-w-[1240px] mx-auto px-5 text-center">
            <h1 className="font-head text-3xl md:text-5xl font-bold text-white">Find a Career Counsellor</h1>
            <p className="text-white/75 mt-4 max-w-2xl mx-auto">
              Browse our network of verified counsellors and request the expert who fits your needs.
            </p>
          </div>
        </section>

        <section className="max-w-[1240px] mx-auto px-5 py-10 md:py-14">
          {/* filters */}
          <div className="bg-white rounded-2xl cc-shadow-card p-5 mb-10 grid grid-cols-1 md:grid-cols-[1fr_auto_auto] gap-4">
            <div className="relative">
              <Search size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#8a90a0]" />
              <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search by name, specialization..."
                className="w-full pl-10 pr-4 py-3 rounded-lg border border-gray-200 focus:border-[#2b8cf0] outline-none transition" />
            </div>
            <select value={city} onChange={(e) => setCity(e.target.value)} className="px-4 py-3 rounded-lg border border-gray-200 focus:border-[#2b8cf0] outline-none">
              {cities.map((c) => <option key={c} value={c}>{c === "all" ? "All Cities" : c}</option>)}
            </select>
            <select value={spec} onChange={(e) => setSpec(e.target.value)} className="px-4 py-3 rounded-lg border border-gray-200 focus:border-[#2b8cf0] outline-none">
              {specs.map((s) => <option key={s} value={s}>{s === "all" ? "All Specializations" : s}</option>)}
            </select>
          </div>

          {loading ? (
            <div className="text-center text-[#5a6274] py-16">Loading counsellors...</div>
          ) : filtered.length === 0 ? (
            <div className="text-center text-[#5a6274] py-16 flex flex-col items-center gap-3">
              <Users size={40} className="text-[#cdd4e0]" />
              {list.length === 0 ? "Our counsellor directory is coming soon." : "No counsellors match your filters."}
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-7">
              {filtered.map((c) => <CounsellorCard key={c.id} c={c} />)}
            </div>
          )}
        </section>
      </main>
      <Footer />
    </div>
  );
}
